import { render } from "./VerifyRegister.vue?vue&type=template&id=0019259a"
import script from "./VerifyRegister.vue?vue&type=script&lang=js"
export * from "./VerifyRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__